import { useMutation } from '@tanstack/react-query';

import { openapiClient } from '@/lib/openapi-fetch';
import { useQueryActions } from '@/hooks/useQueryActions';
import type { FetchError } from '@/types/api';

import { rfiKeys } from '../../servicerequests/services/keys';
import { type SupportResponse } from '../types';

export const useUnifiedApiPostSupport = () => {
  const { invalidateQueries } = useQueryActions();

  return useMutation<SupportResponse, FetchError, FormData>({
    mutationFn: async (formData: FormData) => {
      const { data, error } = await openapiClient.POST('/issue/rfis', {
        body: formData as any,
        bodySerializer: (body) => body,
      });
      if (error) throw new Error(JSON.stringify(error));
      return data as unknown as SupportResponse;
    },
    onSuccess: () => {
      invalidateQueries([rfiKeys.table(), rfiKeys.gfx(), rfiKeys.dashboard()]);
    },
  });
};
